<template>
  <div id="SectionEcovadisPartners">
    <UIContainer>
      <template #left>
        <SectionTitle>
          <template #title>
            <span class="SectionEcovadisPartners__title">
              Our Ecovadis training partners will help you tackle
            </span>
          </template>
          <template #description>
            <span class="SectionEcovadisPartners__description">
              Our process is collaborative. To ensure a smooth and rapid journey
              to your target score, we'll need a few things from your team. In
              return, we provide a clear, structured path so nothing ever slips.
              <h3 class="SectionEcovadisPartners__description-title">
                What we'll need from you:
              </h3>
              1. Assign a coordinator to be our primary point of contact. <br />
              2. Confirm all sites & entities that are in scope for the
              assessment. <br />
              3. Provide necessary information in a timely manner.
              <br />
            </span>
          </template>
        </SectionTitle>
      </template>

      <template #right>
        <img
          class="SectionEcovadisPartners__image"
          src="./assets/ecovadisPartners/ecovadis.avif"
          alt="EcoVadis readiness support illustration"
          loading="lazy"
        />
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionEcovadisPartners {
  .SectionEcovadisPartners__title {
    @include font-size-18px();
    @include md {
      @include font-size-30px;
    }
  }
  .SectionEcovadisPartners__description {
    @include font-size-16px();
    color: $color-ui-gray-cool-600;
    @include md {
      @include font-size-18px;
    }
  }

  .SectionEcovadisPartners__description-title {
    @include font-size-16px();
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 0.5rem;

    @include md {
      @include font-size-20px;
    }
  }

  .SectionEcovadisPartners__image {
    display: none;
    padding-left: 0;

    @include md {
      display: block;
      width: 100%;
      height: auto;
      border-radius: 24px;
      padding-left: 1rem;
    }
  }
}
</style>
